<div class="snackbar-wrapper" [ngClass]="data.status">
    <div class="snackbar-content">
        <mat-icon class="status-icon">{{ getIcon(data.status) }}</mat-icon>
        <span class="message">{{ data.message | translate }}</span>
    </div>
    <button mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
    </button>
</div>
